import { useEffect, useState } from "react";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { IncapacityTypeConstantsEditor } from "../../../../../Talentohumano/GestionTH/EmployeeIncapacity/IncapacityEditors/IncapacityTypeConstants.editor";
import { LiquidateMonthConstantsEditor } from "../../../../../Talentohumano/GestionTH/EmployeeIncapacity/IncapacityEditors/LiquidateMonthConstantsEditor";
import { toast } from "react-toastify";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const THIN001 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({})
    const [bean, setBean] = useState<any>({
        IDAccount: _single.getAccountID()
    })

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(bean.Obs?? "Se Cargo la Incapacidad")
        }
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean)
        }
        if (configProcedure?._pushProps) {
            configProcedure?._pushProps(bean)
        }
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            onExportMap()
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Type", "FromDate", "UptoDate", "Year", "Month"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-6">
                <label className={`${missingFields.includes('Type') ? 'has-error' : ''}`}>Tipo de Incapacidad</label>
                <IncapacityTypeConstantsEditor idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} label=" " />
            </div>
            <div className="col-6">
                <label className={`${missingFields.includes('FromDate') ? 'has-error' : ''}`}>Inicio en</label>
                <InputDate label=" " name="FromDate" value={bean.FromDate} setDate={(e: any) => { setBean({ ...bean, 'FromDate': e }) }} />
            </div>
            <div className="col-6">
                <label className={`${missingFields.includes('UptoDate') ? 'has-error' : ''}`}>Terminación en</label>
                <InputDate label=" " name="UptoDate" value={bean.UptoDate} setDate={(e: any) => { setBean({ ...bean, 'UptoDate': e }) }} />
            </div>
            <div className="col-6">
                <label className={`${missingFields.includes('Year') ? 'has-error' : ''}`} >Año a Aplicar</label>
                <input type="number" className="form-control" name="Year" value={bean.Year} onChange={(e) => { setBean({ ...bean, Year: e.target.value }) }} />
            </div>
            <div className="col-6">
                <label className={`${missingFields.includes('Month') ? 'has-error' : ''}`} >Mes a Aplicar</label>
                <LiquidateMonthConstantsEditor label=" " idSelector={bean.Month} onChange={(e) => { setBean({ ...bean, "Month": e }) }} />
            </div>
            <div className="col-md-12">
                <label >Razón de la Incapacidad</label>
                <textarea className="form-control" value={bean.Obs} onChange={(e) => { setBean({ ...bean, Obs: e.target.value }) }}></textarea>
            </div>

            <div className="col-md-12 mt-4">
                <BasicButton eventClick={validateData} icon="ri-send-plane-line" children={`Registrar Solicitud`} />
            </div>
        </div>
    );
}